import { TFunction } from 'i18next';

export const columns = (t: TFunction) => (
  [
    { id: 'setting', label: t('common:setting') },
    { id: 'payees', label: t('common:payeesLabel') },
    { id: 'payers', label: t('common:payersLabel') },
    { id: 'buyer-before-closing', label: t('common:beforeClosingLabel') },
    { id: 'buyer-at-closing', label: t('common:atClosingLabel') },
    { id: 'seller-before-closing', label: t('common:beforeClosingLabel') },
    { id: 'seller-at-closing', label: t('common:atClosingLabel') },
    { id: 'by-others', label: t('common:byOthersLabel') },
    { id: 'preset-amount', label: t('common:presetAmountLabel') },
    { id: 'options', label: t('common:actionsHeader') },
  ]
);
